var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgUpdatePdfIcon = function SvgUpdatePdfIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#D14339",
    clipPath: "url(#update-pdf-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M23.333 11.67a7 7 0 0 1-8.302-7.537H7a2.33 2.33 0 0 0-2.322 2.333l-.011 18.667a2.33 2.33 0 0 0 2.321 2.333H21a2.34 2.34 0 0 0 2.333-2.333zM8.182 19.867h.898q.684 0 1.176-.226.496-.231.762-.641.265-.41.265-.96a1.86 1.86 0 0 0-.265-.993 1.83 1.83 0 0 0-.762-.688q-.492-.25-1.176-.25H6.81v5.688h1.372zm0-1.058v-1.641h.898q.29 0 .469.125a.7.7 0 0 1 .262.32q.085.2.085.434a.9.9 0 0 1-.085.394.6.6 0 0 1-.262.27 1 1 0 0 1-.469.098zm5.45 2.988h.477q.57 0 1.047-.195a2.45 2.45 0 0 0 1.375-1.426q.195-.5.195-1.102v-.238q0-.605-.195-1.102a2.5 2.5 0 0 0-.547-.863 2.4 2.4 0 0 0-.836-.562q-.48-.2-1.058-.2h-1.828v5.688h1.371m0-1.055h.477q.39 0 .66-.187.274-.187.414-.559.145-.375.145-.922v-.246q0-.41-.082-.719a1.4 1.4 0 0 0-.235-.52 1 1 0 0 0-.39-.316 1.3 1.3 0 0 0-.531-.105h-.457zm5.42-3.574v1.309h2.211v1.054h-2.21v2.266H17.68v-5.688h3.805v1.059z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 1.498A5.095 5.095 0 0 1 27.2 5.1a5.095 5.095 0 0 1-10.029 1.275H18.5a3.82 3.82 0 0 0 3.604 2.55A3.83 3.83 0 0 0 25.931 5.1a3.83 3.83 0 0 0-3.828-3.825c-1.059 0-2.003.44-2.692 1.135l2.054 2.053H17V0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "update-pdf-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUpdatePdfIcon);
export default ForwardRef;